<template>
    <div class="contacts-sales">
        <div class="contats-sales-list-mobile" v-if="isMobileChecker">
            <div class="list-item" v-for="(item, index) in contactsPage.sales_offices" @click="setActiveOfficeArr(item, index), openMapMobile()" :data-lat="item.map_lat" :data-lng="item.map_lng">
                <div class="num">{{ index + 1 }}</div>
                <strong>{{ item.name }}</strong>
                <p>{{ item.adres }}</p>
                <svgIcon name="arrow-right" class="icon-right-arrow"/>
            </div>
        </div>
        <div class="contacts-sales-map-container" :class="{'openMapMobile' : openMobileMap}">
            
            <div class="sales-offices-list">
                <div class="list-item" v-for="(item, index) in contactsPage.sales_offices" @click="setActiveOfficeArr(item, index)" :data-lat="item.map_lat" :data-lng="item.map_lng">
                    <div class="num">{{ index + 1 }}</div>
                    <strong>{{ item.name }}</strong>
                    <p>{{ item.adres }}</p>
                    <svgIcon name="arrow-right" class="icon-right-arrow"/>
                </div>
                <div class="list-item-fullinfo" :class="{'open' : officeFull}" v-if="officeArr != null">
                    <div class="back" @click="officeFull = false">
                        <svgIcon name="arrow-back" class="icon-arrow-back"/>
                        <span v-if="globalLang == ''">Назад к списку всех офисов</span>
                        <span v-else>Барлық кеңселер тізіміне оралу</span>
                    </div>
                    <div class="office-name">
                        <div class="num">{{ officeArrIndex }}</div>
                        <strong>{{ officeArr.name }}</strong>
                    </div>
                    <div class="office-info">
                        <a :href="'tel:' + officeArr.phone">{{ officeArr.phone }}</a>
                        <div class="info-item adres"><svgIcon name="pin-c" class="icon-pin"/><span>{{ officeArr.adres }}</span></div>
                        <div class="info-item time"><svgIcon name="time" class="icon-time"/><span>{{ officeArr.time }}</span></div>
                    </div>
                </div>
            </div>
            <div class="map" id="contactsMap"></div>
            <button class="close-link-mobile" @click.prevent="closeMobileMap" v-if="isMobileChecker"><svgIcon name="close" class="icon-svg"/></button>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'contacts-sales',
        components: {
            svgIcon,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Офисы продаж',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                openMobileMap: false,
                officeArr: null,
                officeArrIndex: null,
                officeFull: false,
                zoom: 13,

                offsetHorizontal: 0,
                offsetVertical: 150,
                activeBallon: null,
                lockMap: false,
            }
        },
        computed: mapGetters({
            contactsPage: 'loadContactsPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            setActiveOfficeArr(arr, index) {
                this.officeArr = arr;
                this.officeArrIndex = index + 1;
                this.officeFull = true;
            },
            openMapMobile() {
                if (this.isMobileChecker) {
                    document.getElementsByTagName('body')[0].classList.add('overlay-open');
                    document.getElementById('header').classList.add('hideMobile');
                    document.getElementById('footer').classList.add('hideMobile');
                    setTimeout(() => {
                        this.openMobileMap = true;
                    }, 100);
                }
            },
            closeMobileMap() {
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('hideMobile');
                document.getElementById('footer').classList.remove('hideMobile');
                this.openMobileMap = false;
            },
            initMap() {
                this.$loadScript("https://api-maps.yandex.ru/2.1/?apikey=e684e26f-c03a-4724-9b73-bca23bfbccaf&lang=ru_RU")
                .then(() => {
                    if (this.contactsPage != null) {
                        // const initMobilePinInfo = this.initMobilePinInfo;
                        var arrSales = this.contactsPage.sales_offices;
                        var _self = this;
                        var zoom = this.zoom;
                        var offset_horizontal = this.offsetHorizontal;
                        var offset_vertical = this.offsetVertical;
                        var i;
                        var Ymap;
                        ymaps.ready().then(function() {
                            var initMap = function() {
                                Ymap = new ymaps.Map('contactsMap', {
                                    center: [_self.contactsPage.almaty_crds.lng, _self.contactsPage.almaty_crds.lat],
                                    zoom: zoom,
                                    controls: [],
                                    behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch", "scrollZoom"]
                                },{suppressMapOpenBlock: false, minZoom: 11, maxZoom: 18, yandexMapDisablePoiInteractivity: true});
                                // Ymap.controls.add('zoomControl', {position: {right: '10px', top: '180px'}});
                                // Ymap.options.set('maxAnimationZoomDifference', Infinity);
                                var btnZoomInLayout = ymaps.templateLayoutFactory.createClass(
                                    '<button class="btn-zoom-in ymap-home-btn-zoom"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13 11V5H11V11H5V13H11V19H13V13H19V11H13Z"></path></svg></button>'
                                );
                                var btnZoomOutLayout = ymaps.templateLayoutFactory.createClass(
                                    '<button class="btn-zoom-out ymap-home-btn-zoom"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 11V13L19 13V11L5 11Z"></path></svg></button>'
                                );
                                var zoomInButton = new ymaps.control.Button({
                                    data: { content: '' },
                                    options: { selectOnClick: false, layout: btnZoomInLayout }
                                });
                                var zoomOutButton = new ymaps.control.Button({
                                    data: { content: '-' },
                                    options: { selectOnClick: false, layout: btnZoomOutLayout }
                                });
                                zoomInButton.events.add('click', function () {
                                    Ymap.setZoom(Ymap.getZoom() + 1, { duration: 300, checkZoomRange: true });
                                });
                                zoomOutButton.events.add('click', function () {
                                    Ymap.setZoom(Ymap.getZoom() - 1, { duration: 300, checkZoomRange: true });
                                });
                                Ymap.controls.add(zoomInButton, { float: 'none', position: { top: 170, right: 20 } });
                                Ymap.controls.add(zoomOutButton, { float: 'none', position: { top: 225, right: 20 } });
                            };
                            
                            var buildPinsOnMap = function() {
                                // console.log(arrSales, arrSales.length)
                                for (i = 0; i < arrSales.length; i++) {
                                    var lat = arrSales[i].map_lat,
                                        lng = arrSales[i].map_lng;
                                        // office_name = _self.contactsPage[i].sales_offices.name;
                                    
                                    const customLayout = ymaps.templateLayoutFactory.createClass(
                                        '<div class="yandex-dial-point" style="width: $[properties.iconWidth]px; height: $[properties.iconHeight]px;">'+ 
                                            '<div class="point-layout">' +
                                                '<div class="marker-num">'+ Math.floor(i + 1) + '</div>' +
                                                '<div class="marker-info">' +
                                                    '<h3>' + arrSales[i].name + '</h3>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>'
                                    );

                                    const myPlacemark = new ymaps.Placemark([lng, lat], 
                                        {
                                            hintContent: '',
                                            balloonContent: "",
                                        },
                                        {
                                            preset: "islands#circleDotIcon",
                                            iconLayout: customLayout,
                                            iconImageSize: [8, 8],
                                            iconImageOffset: [-4, -8],
                                            zIndex: 730,
                                            zIndexActive: 732,
                                            zIndexHover: 731,
                                            iconPane: "overlaps",
                                            // data_title:  _self.salesItems[i].name.name,
                                            // data_slug: _self.salesItems[i].name.slug,
                                            // data_adres: _self.salesItems[i].project_adres,
                                            // data_price: _self.salesItems[i].project_price_full,
                                        }
                                    );
                                    Ymap.geoObjects.add(myPlacemark);
                                    // myPlacemark.events.add("click", (function(e) {
                                    //     if (_self.isMobileChecker) {
                                    //         e.preventDefault();
                                    //         _self.initMobilePinInfo = true;
                                    //         // var data = myPlacemark.options.get('iconLayout').data;
                                    //         const dataAtribute = e.get('target').options.get('data_title');
                                    //         _self.infoMobilePinData.link = e.get('target').options.get('data_slug')
                                    //         _self.infoMobilePinData.title = e.get('target').options.get('data_title')
                                    //         _self.infoMobilePinData.adres = e.get('target').options.get('data_adres')
                                    //         _self.infoMobilePinData.price = e.get('target').options.get('data_price')
                                    //         console.log(dataAtribute, _self.infoMobilePinData, 'asdasdas 99999')
                                    //     }
                                    // }));
                                }
                            };

                            var setCenterOffset = function() {
                                var pixelCenter = Ymap.getGlobalPixelCenter('Ymap');
                                pixelCenter = [
                                    pixelCenter[0] + offset_horizontal,
                                    pixelCenter[1] - offset_vertical
                                ];
                                var geoCenter = Ymap.options.get('projection').fromGlobalPixels(pixelCenter, Ymap.getZoom());
                                Ymap.setCenter(geoCenter);
                            };

                            var clicker = function() {
                                $('.sales-offices-list .list-item').on('click', function() {
                                    var latPin = parseFloat($(this).attr('data-lat')),
                                        lngPin = parseFloat($(this).attr('data-lng'));
                                    Ymap.panTo([lngPin, latPin], {
                                        safe: false,
                                        smooth: true,
                                        flying: false,
                                        duration: 600,
                                        useMapMargin: true,
                                    }).then(function() {
                                        Ymap.setZoom(17, { 
                                            smooth: true
                                        })
                                    })
                                });
                            };

                            var clickerMobile = function() {
                                $('.contats-sales-list-mobile .list-item').on('click', function() {
                                    var latPin = parseFloat($(this).attr('data-lat')),
                                        lngPin = parseFloat($(this).attr('data-lng'));
                                    Ymap.panTo([lngPin, latPin], {
                                        safe: false,
                                        smooth: true,
                                        flying: false,
                                        duration: 10,
                                        useMapMargin: true,
                                    }).then(function() {
                                        Ymap.setZoom(18, { 
                                            smooth: true
                                        }).then(function() {
                                            setCenterOffsetMobile();
                                        })
                                    })
                                });
                            };

                            var setCenterOffsetMobile = function() {
                                var pixelCenter = Ymap.getGlobalPixelCenter('Ymap');
                                pixelCenter = [
                                    pixelCenter[0] - 0,
                                    pixelCenter[1] + 50
                                ];
                                var geoCenter = Ymap.options.get('projection').fromGlobalPixels(pixelCenter, Ymap.getZoom());
                                Ymap.setCenter(geoCenter);
                            };

                            initMap();
                            buildPinsOnMap();
                            setCenterOffset();
                            clicker();
                            if (_self.isMobileChecker) {
                                clickerMobile();
                            }
                        });
                    }
                });
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.initMap();
            this.setActiveOfficeArr(this.contactsPage.sales_offices[0], 1);
            this.officeFull = false;
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/contacts-page/contacts-sales.scss';
    @import '@/styles/components/contacts-page/respond/contacts-sales-respond.scss';
</style>